// components/RequireVip.jsx
import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Lock as LockIcon } from '@mui/icons-material';
import { Box, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import VipTeaser from './VipTeaser';


export default function RequireVip({ 
  children, 
  variant = 'teaser-full',
  message = 'Dostęp tylko dla VIP',
  blurAmount = '4px',
  sx = {},
  requirement = 'vip'  // nowy kluczowy prop: 'free', 'logged_in', 'vip', 'poland', 'regions', 'europe' itp.
}) {
  const { user, loading, hasRole, vipModeEnabled } = useAuth();

  if (loading) return <div>Ładowanie...</div>;

  // ───────────────────────────────────────────────
  // Logika dostępu na podstawie requirement
  // ───────────────────────────────────────────────
  let isAllowed = !vipModeEnabled || hasRole('admin'); // admin zawsze OK
  
  switch (requirement) {
    case 'free':
      isAllowed = true;
      break;
    case 'login':
      isAllowed = !!user;
      break;
    default: // 'vip', 'poland', 'regions', 'europe' itp.
      isAllowed = isAllowed || hasRole(requirement);
  }

  if (isAllowed) return children;

  // ───────────────────────────────────────────────
  // Dynamiczny komunikat + link w zależności od requirement
  // ───────────────────────────────────────────────
  let teaserMessage = message;
  let linkTo = '/vip';
  let buttonText = 'Kup dostęp VIP';

  if (requirement === 'login') {
    teaserMessage = 'Zaloguj się aby zobaczyć';
    linkTo = '/login';
    buttonText = 'Zaloguj się';
  } else if (requirement === 'poland') {
    teaserMessage = 'Dostępne w pakiecie Polska';
	linkTo = '/vip';
  } else if (requirement === 'poland_regions') {
    teaserMessage = 'Dostępne w pakiecie Regiony';
	linkTo = '/vip';
  } // dodawaj kolejne role wg potrzeb

  // Warianty blokady (bez zmian)
  switch (variant) {
    case 'lock-icon':
      return (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <LockIcon fontSize="large" color="disabled" />
          <Typography variant="body2" color="text.secondary" mt={1}>
            {teaserMessage}
          </Typography>
        </Box>
      );

    case 'blur':
      return (
        <Box sx={{ 
          position: 'relative', 
          filter: `blur(${blurAmount})`, 
          pointerEvents: 'none' 
        }}>
          {children}
          <Box sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',            
            color: 'white',
            borderRadius: 1,
          }}>            
          </Box>
        </Box>
      );

    case 'simple-text':
      return (
        <Typography sx={sx}>
          {teaserMessage}
        </Typography>
      );
	  
	case 'short-text':
      return (
        <Typography sx={sx}>
            (VIP)
        </Typography>
      );
	  
	  case 'nothing':
      return (
        <Typography>
            
        </Typography>
      );

    case 'teaser-full':
      return (
        <Box sx={{ textAlign: 'center', py: 6 }}>
          <Typography variant="h6" gutterBottom>
            {teaserMessage}
          </Typography>
          <Button 
            variant="contained" 
            component={RouterLink} 
            to={linkTo}
            sx={{ mt: 2 }}
          >
            {buttonText}
          </Button>
        </Box>
      );
	  
	  case 'vip-teaser':
		return <VipTeaser/>
		

		
    default:
      return (
        <Box sx={{ textAlign: 'center', py: 6 }}>
          <Typography variant="h6" gutterBottom>
            {teaserMessage}
          </Typography>
          <Button 
            variant="contained" 
            component={RouterLink} 
            to={linkTo}
            sx={{ mt: 2 }}
          >
            {buttonText}
          </Button>
        </Box>
      );
  }
}